var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1066_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0797 9.80101L9.3342 10.333C7.47973 9.40221 6.3342 8.33301 5.66753 6.66634L6.18083 3.91294L5.21054 1.33301H2.70993C1.95823 1.33301 1.36629 1.95419 1.47856 2.69746C1.75883 4.55301 2.58522 7.91734 5.00086 10.333C7.53766 12.8698 11.1913 13.9706 13.2022 14.4081C13.9787 14.5771 14.6675 13.9713 14.6675 13.1767V10.7871L12.0797 9.80101Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1066_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.dd03dcdcb3265aba422c9256822de325.svg";
export { ForwardRef as ReactComponent };